// src/data/skills.js
export const skills = [
  { 
    category: "Backend Development", 
    icon: "Terminal",
    items: ["Java", "Spring Boot", "Python", "Node.js", "Microservices Architecture"] 
  },
  { 
    category: "Database Systems", 
    icon: "Database",
    items: ["PostgreSQL", "MongoDB", "Redis", "Cassandra", "Oracle"] 
  },
  { 
    category: "Cloud & DevOps", 
    icon: "Cloud",
    items: ["AWS", "Docker", "Kubernetes", "CI/CD", "Terraform"] 
  },
  { 
    category: "System Architecture", 
    icon: "Server",
    items: ["Distributed Systems", "High-Frequency Trading", "System Design", "Performance Optimization"] 
  }
];
